import React from "react";
import { Link } from "react-router-dom";
import { trackMarketingFunnel } from "../../utils/marketingAnalytics";

export const LandingCta = () => (
  <section id="cta" className="scroll-mt-24 bg-white pb-10 md:pb-14">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="relative overflow-hidden rounded-2xl border border-blue-100 bg-gradient-to-r from-blue-700 to-blue-800 px-5 py-8 text-center sm:px-8 sm:py-10">
        <div className="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full bg-teal-400/20 blur-2xl" />
        <h2 className="text-2xl font-bold text-white md:text-3xl">
          There's an electric future ahead, let's plan for it together.
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm text-blue-100 sm:text-base">
          Let's talk about how we can help you plan for the future.
        </p>
        <div className="mt-5 flex flex-col justify-center gap-2.5 sm:flex-row">
          <Link
            to="/contact"
            onClick={() => trackMarketingFunnel("homepage_cta_contact_click")}
            className="inline-flex items-center justify-center rounded-lg bg-white px-6 py-2.5 text-sm font-semibold text-blue-700 hover:bg-blue-50"
          >
            Get in touch
          </Link>
          <Link
            to="/products"
            className="inline-flex items-center justify-center rounded-lg border border-white/40 px-6 py-2.5 text-sm font-semibold text-white hover:bg-white/10"
          >
            Compare products
          </Link>
        </div>
      </div>
    </div>
  </section>
);
